import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useDetailStaff = (id: number | string) =>
  useQuery(
    ['detailStaff', id],
    async () => {
      if (id) {
        const res = await api.get(`/api/cms/admin/${id}`);
        return res.data.data;
      }
      return;
    },
    {
      retry: 0,
    }
  );
